
import { ComputedRef, defineComponent } from "vue";
import { useStore } from "vuex";
import TeamStatistics from "./TeamStatistics.vue";
import RankingStatistics from "./RankingStatistics.vue";
import GeneralStatistics from "./GeneralStatistics.vue";
import AccessesStatistics from "./AccessStatistics.vue";
import { isCirculoTemplate } from "../../mixins";
import { computed } from "@vue/reactivity";
import { User } from "../../../../../domain/entities/entities";

export default defineComponent({
  name: "UserStatistics",
  components: {
    AccessesStatistics,
    GeneralStatistics,
    RankingStatistics,
    TeamStatistics
  },

  setup() {
    const store = useStore();

    /** User getter.
     * @see User. */
    const user: ComputedRef<User> = computed(() => {
      return store.getters["userProfile_module/user"];
    });

    const hasCompany = computed(() => {
      return (
        Array.isArray(user.value.companies) &&
        user.value.companies.some(company => company.id > 0)
      );
    });

    return {
      store,
      hasCompany,
      isCirculoTemplate
    };
  }
});
